// export const FormMenu = [
//   { title: "담당" },
//   { title: "서버구분" },
//   { title: "모델" },
//   { title: "OS" },
//   { title: "DB" },
//   { title: "계약정보" },
//   { title: "서버정보" },
//   { title: "디스크정보" },
//   { title: "프로그램정보" },
//   { title: "DB정보" },
//   { title: "WEB정보" },
//   { title: "학사정보" },
//   { title: "ODISU" },
//   { title: "특이사항" },
// ];

export const FormMenu = [
  { title: "담당" },
  { title: "계약정보" },
  { title: "서버정보" },
  { title: "디스크정보" },
  { title: "프로그램정보" },
  { title: "DB정보" },
  { title: "WEB정보" },
  { title: "학사정보" },
  { title: "ODISU" },
  { title: "특이사항" }
];

export const detailForm = [
  { title: "반응형", view: "setting", type: "date", date: "", value: "" },
  { title: "웹접근성", view: "setting", type: "date", date: "", value: "" },
  { title: "아르고스", view: "setting", type: "date", date: "", value: "" },
  {
    title: "스마트모바일시스템",
    view: "setting",
    type: "date",
    date: "",
    value: ""
  },
  {
    title: "키오스크좌석관리",
    view: "setting",
    type: "date",
    date: "",
    value: ""
  },
  { title: "분실방지", view: "setting", type: "date", date: "", value: "" },
  {
    title: "UNIPASS시스템",
    view: "setting",
    type: "date",
    date: "",
    value: ""
  },
  { title: "SMS서비스", view: "setting", type: "date", date: "", value: "" },
  {
    title: "대출싸인시스템",
    view: "setting",
    type: "date",
    date: "",
    value: ""
  },
  {
    title: "자료위치안내시스템",
    view: "setting",
    type: "date",
    date: "",
    value: ""
  },
  {
    title: "독서인증시스템",
    view: "setting",
    type: "date",
    date: "",
    value: ""
  },
  {
    title: "DID시스템",
    view: "setting",
    type: "date",
    date: "",
    value: ""
  },
  { title: "기타", view: "setting", type: "text", date: "", value: "" },
  { title: "담당", view: "area", type: "textarea", date: "", value: "" },
  { title: "지역", view: "area", type: "textarea", date: "", value: "" },
  { title: "유지보수", view: "area", type: "textarea", date: "", value: "" },
  { title: "계약정보", view: "area", type: "textarea", date: "", value: "" },
  { title: "서버정보", view: "area", type: "textarea", date: "", value: "" },
  { title: "디스크정보", view: "area", type: "textarea", date: "", value: "" },
  {
    title: "프로그램정보",
    view: "area",
    type: "textarea",
    date: "",
    value: ""
  },
  { title: "DB정보", view: "area", type: "textarea", date: "", value: "" },
  { title: "WEB정보", view: "area", type: "textarea", date: "", value: "" },
  { title: "학사정보", view: "area", type: "textarea", date: "", value: "" },
  { title: "ODISU", view: "area", type: "textarea", date: "", value: "" },
  { title: "특이사항", view: "area", type: "textarea", date: "", value: "" }
];
